<template>
<h4>
    <slot></slot>
</h4>
</template>

<script>
export default {
    
}
</script>